<template>
  <button class="action-button columns is-flex is-align-items-center mx-2 my-1 px-3"
          style="border: 1px solid lightgrey;border-radius:0.5rem;height:8rem;cursor:pointer;"
          @click="openShareModal(props.action)">
    <div class="column is-flex is-2 p-0">
      <img class="is-flex-align-items-center" :src="props.action.logo_url" />
    </div>
    <div class="is-align-self-flex-start is-flex is-flex-direction-column py-3 pl-2">
      <div class="is-flex is-align-items-center is-justify-content-space-between">
        <h4 class="has-text-black has-text-weight-bold has-text-left fade-text">
          {{ props.action.integration_name }}
        </h4>
        <span v-if="props.action.connected" class="tag is-small has-text-black"
              style="background-color: #defde9;">
          <span class="icon is-small">
            <font-awesome-icon icon="check" />
          </span>
          <span>Active</span>
        </span>
        <span v-else class="tag is-small" style="background-color:#ddd;">
          <span>Inactive</span>
        </span>
      </div>
      <p class="is-size-7 py-1 has-text-grey-dark has-text-left" style="overflow-y:hidden;height:4rem;">
        {{ props.action.action_description }}
      </p>
    </div>
  </button>
</template>

<script setup>
const props = defineProps(['action'])
const emit = defineEmits(['share-modal-opened'])

function openShareModal(service) {
  emit('share-modal-opened', service);
}

</script>

<style scoped>
 .action-button:hover {
   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
 }
</style>
